<template>
  <v-app-bar
    app
    v-scroll="onScroll"
    :color="!isScrolling ? 'transparent' : !darkMode ? 'white' : 'dark'"
    fixed
    flat
    width="100vw"
  >
    <v-slide-x-transition>
      <v-img v-if="showLogo" :src="logo" class="shrink" contain />
    </v-slide-x-transition>

    <v-spacer />

    <v-menu :close-on-content-click="false">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item v-for="item in menuItems" :key="item.id" class="menuLink">
          <v-list-item-title class="text-center">
            <span
              class="ma-6 pa-6 menuLink-a"
              v-scroll-to="{
                el: `#${item.name}`,
                duration: 500,
                container: 'body',
                easing: 'linear',
                cancelable: false,
              }"
            >
              {{ $t(`Main.${item.name}`) }}
            </span>
          </v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-switch
            class="mx-auto"
            v-model="darkMode"
            primary
            color="primary"
            :label="$t(`Main.DarkMode`)"
            dense
          />
        </v-list-item>
        <v-list-item>
          <v-row justify="center">
            <v-menu
              offset-y
              offset-overflow
              v-model="showLanguageMenu"
              width="100%"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="text-center menuLink-a"
                  min-width="100%"
                >
                  {{ $t("Main.ChangeLocale") }}
                </v-btn>
              </template>
              <v-list width="100%">
                <v-list-item v-for="locale in locales" :key="locale">
                  <v-btn
                    class="text-center menuButton"
                    min-width="100%"
                    @click="changeLocale(locale)"
                  >
                    {{ locale }}
                  </v-btn>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-row>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  name: "CoreAppBar",

  components: {},

  data: () => ({
    showLogo: false,
    isScrolling: false,
    showLanguageMenu: false,
    locales: process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(","),
  }),

  mounted() {
    this.$store.dispatch("settings/createMenuItems");
    this.scrollToTop();
    if (this.$store.getters["settings/color"] == undefined) {
      this.$store.dispatch("settings/loadColorFromVuetify");
    }
  },
  methods: {
    onScroll() {
      const offset = window.pageYOffset;
      this.isScrolling = offset > 50;
      this.showLogo = offset > 50;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    changeLocale(locale) {
      if (this.$i18n.locale !== locale) {
        this.$store.dispatch("settings/locale", locale);
      }
    },
  },
  watch: {
    darkMode: {
      handler(oldVal, newVal) {
        if (oldVal != newVal) {
          this.scrollToTop();
        }
      },
      deep: true,
    },
  },
  computed: {
    logo() {
      return this.$store.getters["settings/logo"];
    },
    darkMode: {
      get() {
        return this.$store.getters["settings/darkMode"];
      },
      set(value) {
        this.$store.dispatch("settings/darkMode", value);
      },
    },
    menuItems() {
      return this.$store.getters["settings/menuItems"];
    },
  },
};
</script>
<style lang="scss">
.menuLink:hover {
  background-color: darkslategray;
}

.menuLink-a:active {
  font-style: italic;
  font-weight: bold;
  color: darkorange;
}

.menuLink-a:hover {
  cursor: pointer;
}

.menuButton:active {
  color: darkorange;
}
html {
  scroll-behavior: smooth;
}
</style>
